// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7kqfE","header":"styles_header__eoUNC","back":"styles_back__udzPU","content":"styles_content__DAI5j"};